import * as React from 'react';
import { SVGProps } from 'react';

const IconCardsCompactSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7 3H1v4h6V3ZM7 9H1v4h6V9ZM9 3h6v4H9V3ZM15 9H9v4h6V9Z" />
  </svg>
);
export default IconCardsCompactSizeS;
